// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611040438/js/" + chunkId + "." + {"44":"08204d5d","225":"81bc410c","481":"3a9e9f17","486":"9825c91c","770":"8de34c1e"}[chunkId] + ".0.8199288994952537.chunk.js";
};